import {
  EUserPermissions,
  EUserStatus,
  EUserType, EViewedUpdate,
  ITokenPayload,
  IUserCustomPermission,
  IUserRolePermission,
  ZUNTA_DATA_ENTRY_ID
} from '@zunta/configurations'
import moment from 'moment-timezone'

interface IJWT {
  exp: number
}

export class User {
  data: ITokenPayload & IJWT
  expireDefault: number

  constructor (data: ITokenPayload & IJWT) {
    this.data = data
    this.expireDefault = 20 * 60 * 1000
  }

  getTimezone (): number {
    const isDst = moment.tz(new Date(), 'America/New_York').isDST()
    let timezone = this.data && this.data.timezone !== undefined && this.data.timezone !== null ? this.data.timezone : -5
    if (isDst) {
      timezone += 1
    }
    return timezone
  }

  isManager (): boolean {
    return this.data.type === EUserType.CLIENT
  }

  isAllFacilitiesAvailable () {
    return this.data.isAllFacilities
  }

  get userRole () {
    if (!this.data || !this.data.role) {
      return ''
    }
    return this.data.role.name
  }

  get userRoleId () {
    if (!this.data || !this.data.role) {
      return ''
    }
    return this.data.role.id
  }

  // isChainAdmin () {
  //   if (!this.data || !this.data.role) {
  //     return false
  //   }
  //   return this.data.role.name === 'Admin'
  // }

  isAdmin (): boolean {
    return this.data.type === EUserType.ZUNTA
  }

  isDataEntry (): boolean {
    return this.userRoleId === ZUNTA_DATA_ENTRY_ID
  }

  isSystemAdmin () {
    if (this.data && this.data.status === EUserStatus.ACTIVE && this.data.firstName === 'System' && this.data.lastName === 'Admin') {
      return true
    }
    return false
  }

  isResident (): boolean {
    return this.data.type === EUserType.RESIDENT
  }

  isExpired (): boolean {
    return new Date(this.data.exp * 1000).getTime() < Date.now()
  }

  hasPermissionFor (permissionName: EUserPermissions) {
    return !!this.data.permissions.find((permission: IUserRolePermission | IUserCustomPermission) => {
      return permission.permission === permissionName
    })
  }

  getTimeUntilExpire () {
    return this.data.exp * 1000 - Date.now()
  }

  getViewedUpdatesVideos () {
    return this.data.viewedUpdates || []
  }

  isRootAccess () {
    return this.data.rootAccess
  }

  getFullName () {
    return `${this.data.firstName} ${this.data.lastName}`
  }

  getResidents () {
    if (this.data.residents && this.data.residents.length) {
      return this.data.residents
    }
    return []
  }

  setViewedUpdatesVideos (type: EViewedUpdate) {
    if (this.data.viewedUpdates && this.data.viewedUpdates.length) {
      this.data.viewedUpdates.push(type)
    } else {
      this.data.viewedUpdates = [type]
    }
  }
}
